// removed by extract-text-webpack-plugin
module.exports = {"homeScreen":"src-components-HomeScreen-styles__homeScreen--aL6bE","viewSwitcher":"src-components-HomeScreen-styles__viewSwitcher--100Pj","active":"src-components-HomeScreen-styles__active--3Kh5n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeScreen/styles.scss
// module id = 183
// module chunks = 0